export var NoteTypes = {
    info: 'info',
    warning: 'warning',
    success: 'success',
    danger: 'danger',
    dark: 'dark',
};
